import { Component, OnInit } from '@angular/core';
import { SearchOrderService } from './search-order.service';
import { Order } from '../order-list/models/order';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'search-order',
  templateUrl: './search-order.component.html',
  styleUrls: ['./search-order.component.css']
})
export class SearchOrderComponent implements OnInit {

  displayDialog: boolean = false;
  isSearchOrder: boolean = false;
  searchItem: string;
  totalRecords: number = 0;
  order: Order;
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked: boolean = false;
  constructor(private searchOrderService: SearchOrderService, private messagesService: MessagesService) { }

  ngOnInit() {
  }


  /**
   * @function
   * @description: This method is accessed from GUI when enter is pressed from barcode filter
   * Search by OrderId/Container Number/Barocde of a sample/PrimerId to invoke, this method gets total count of matched tube carriers and
   * fetches first 100 records of the list as part of lazy loading
  */
  searchOrderDetails() {
    if (this.searchItem != undefined && this.searchItem != null && this.searchItem != "") {
      this.searchItem = this.searchItem.trim();
      // allow the orderId with length of minmum 4 characters
      this.blocked = true;
      this.searchOrderService.getOrderDetails(this.searchItem).subscribe(
        results => {
          if (!results) {
            return;
          }
          if (results.data) {
            console.log("Order Details:", results.data);
            this.order = results.data;
            /** should be removed once we are not remaining with the materials which exists in BB but processed in GATCLIMS */
            this.order.sequencingPrimers.forEach(primer => {
              if (primer.primerType === "Stored" && (primer.storagePlateBarcode === "" || primer.storagePlateBarcode == null || primer.storagePlateBarcode == undefined))
                primer.isPresentInGatcLims = true
            })
            this.blocked = false
            this.displayDialog = true;

          } else {
            this.blocked = false
            this.messagesService.addErrorMessage({ severity: 'error', summary: results.bbApiError.message, detail: results.bbApiError.title });
          }
        },
        error => {
          this.blocked = false
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
        }
      )
    }
  }

  onDialogHide(event) {
    this.order = null;
    this.displayDialog = event
  }

}
